import React from 'react';
import { Row, Col, Button, Container } from 'react-bootstrap';
import MultiSelect from "react-multi-select-component";
import { useMessaging } from '../../../features/messaging/MessagingContext';

const TopFilterBar = () => {
    const { state, dispatch } = useMessaging();
    const {
        selectedTags, selectedQrCodes,
        selectedFormIds, selectedAdmissionStatuses
    } = state;

    const updateFilters = (payload) => {
        dispatch({ type: 'UPDATE_FILTERS', payload });
    };

    // Mock Options
    const tagOptions = [
        { label: 'High Intent', value: 'high' },
        { label: 'Follow-up', value: 'follow' },
        { label: 'Registered', value: 'reg' }
    ];

    const statusOptions = [
        { label: 'Admitted', value: 'admitted' },
        { label: 'Completed', value: 'completed' },
        { label: 'Assigned', value: 'assigned' },
        { label: 'Not Assigned', value: 'none' }
    ];

    const formOptions = [
        { label: 'Admission Form - 2026', value: 'af26' },
        { label: 'Enquiry Form - Summer', value: 'efsm' }
    ];

    return (
        <div className="top-filter-bar bg-white border-bottom shadow-sm py-2 px-3">
            <Container fluid>
                <Row className="align-items-center">
                    {/* No BRANCH filter — the header's branch selection scopes this page. */}
                    <Col lg={2} md={4} className="mb-md-0 mb-2">
                        <label className="text-muted x-small font-weight-bold mb-1 d-block">CAMPAIGN TAGS</label>
                        <MultiSelect
                            options={tagOptions}
                            value={selectedTags}
                            onChange={(val) => updateFilters({ selectedTags: val })}
                            labelledBy="Select Tags"
                            overrideStrings={{ selectSomeItems: "All Tags" }}
                        />
                    </Col>
                    <Col lg={2} md={4} className="mb-md-0 mb-2">
                        <label className="text-muted x-small font-weight-bold mb-1 d-block">ADMISSION STATUS</label>
                        <MultiSelect
                            options={statusOptions}
                            value={selectedAdmissionStatuses}
                            onChange={(val) => updateFilters({ selectedAdmissionStatuses: val })}
                            labelledBy="Admission Status"
                            overrideStrings={{ selectSomeItems: "All Statuses" }}
                        />
                    </Col>
                    <Col lg={2} md={4} className="mb-md-0 mb-2">
                        <label className="text-muted x-small font-weight-bold mb-1 d-block">FORMS</label>
                        <MultiSelect
                            options={formOptions}
                            value={selectedFormIds}
                            onChange={(val) => updateFilters({ selectedFormIds: val })}
                            labelledBy="Select Forms"
                            overrideStrings={{ selectSomeItems: "All Forms" }}
                        />
                    </Col>
                    <Col lg={2} md={4} className="mb-md-0 mb-2">
                        <label className="text-muted x-small font-weight-bold mb-1 d-block">QR CODES</label>
                        <MultiSelect
                            options={[]} // Add QR options if available
                            value={selectedQrCodes}
                            onChange={(val) => updateFilters({ selectedQrCodes: val })}
                            labelledBy="Select QR Codes"
                            overrideStrings={{ selectSomeItems: "All QR Codes" }}
                        />
                    </Col>
                    <Col lg={2} md={4} className="text-right d-flex align-items-end justify-content-end">
                        <Button
                            variant="link"
                            size="sm"
                            className="text-danger small font-weight-bold p-0"
                            onClick={() => updateFilters({
                                selectedTags: [], selectedQrCodes: [],
                                selectedFormIds: [], selectedAdmissionStatuses: []
                            })}
                        >
                            Reset Filters
                        </Button>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default TopFilterBar;
